import React, { useEffect } from "react";
import {
  Modal,
  Form,
  Input,
  InputNumber,
  Select,
  DatePicker,
  Spin,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { save } from "../../../../features/save/saveSlice";
import toast from "react-hot-toast";

const SubCategoryAdd = ({ isModalOpen, handleCancel, handleFetch, prodd }) => {
  const urlCat = "api/v1/payments/fetch-payment-categories";
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { saving } = useSelector((state) => state.save);
  const { loading, dataCat } = useSelector((state) => ({
    loading: state.fetch.loading,
    dataCat: state.fetch.data[urlCat] || [],
  }));
  const onFinish = async (data) => {
    data.pscId = prodd?.pscId ?? null;
    const res = await dispatch(
      save({ ...data, url: "api/v1/payments/save-sub-category" })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await handleCancel();
      await handleFetch();
      await form.resetFields();
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  useEffect(() => {
    if (prodd) {
      form.setFieldsValue({ ...prodd });
    } else {
      form.resetFields();
    }
  }, [prodd]);

  // const newDatCat = dataCat?.filter((item) => item?.orgOwned);

  return (
    <Modal
      title={`${prodd?.pscId ? "Update" : "Add"} SubCategory`}
      open={isModalOpen}
      onCancel={handleCancel}
      width={850}
      onOk={onFinish}
    >
      <Form layout="vertical" form={form} onFinish={onFinish}>
        <Form.Item
          label="Category"
          name="pcId"
          rules={[{ required: true, message: "Please enter Category" }]}
        >
          <Select
            className=""
            allowClear
            style={{
              width: "100%",
            }}
            options={
              dataCat?.length > 0 &&
              dataCat?.map((item) => ({
                value: item?.pcId,
                label: item?.pcName,
              }))
            }
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.label?.toLocaleLowerCase() ?? "").includes(
                input?.toLocaleLowerCase()
              )
            }
          />
        </Form.Item>
        <Form.Item
          label="Name"
          name="pscName"
          rules={[{ required: true, message: "Please enter Name" }]}
        >
          <Input className="input" />
        </Form.Item>

        <Form.Item
          label="Account Code"
          name="pscAccountCode"
          rules={[{ required: true, message: "Please enter account code" }]}
        >
          <Input className="input" />
        </Form.Item>

        <Form.Item
          label="Account Name"
          name="pscAccountName"
          rules={[{ required: true, message: "Please enter account name" }]}
        >
          <Input className="input" />
        </Form.Item>

        <div className="flex lg:flex-row flex-col justify-between mt-[56px] mb-[48px]">
          <div className="justify-start"></div>
          <div className="justify-end flex items-center gap-x-2">
            <div className="w-[200px]">
              <button
                key="back"
                type="button"
                onClick={handleCancel}
                className="cstm-btn"
              >
                Cancel
              </button>
            </div>

            <div className="w-[200px]">
              <button
                key="submit"
                type="submit"
                className="cstm-btn-2"
                disabled={saving}
              >
                {saving ? <Spin /> : prodd?.pscId ? "Update" : "Save"}
              </button>
            </div>
          </div>
        </div>
      </Form>
    </Modal>
  );
};

export default SubCategoryAdd;
